import { HugeiconsIcon } from '@hugeicons/react';
import {
    ArrowUp01IconStroke
} from '@/components/icons';

import { Accordion, AccordionDetails, AccordionSummary, Typography, Box } from '@mui/material';
import { Info } from '@/components/info';

export const ClientSection = ({
    children,
    title,
    icon,
    helpTopicPath
}: {
    children: React.ReactNode;
    title: string;
    icon: React.ReactNode;
    helpTopicPath?: string;
}) => {
    const heading = (
        <Typography variant="body1" sx={{ fontWeight: 700, ml: 1 }}>
            {title}
        </Typography>
    );

    return (
        <Accordion defaultExpanded disableGutters>
            <AccordionSummary expandIcon={<HugeiconsIcon icon={ArrowUp01IconStroke} strokeWidth={1.5} />} sx={{ px: 2.5, py: 0.25 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main' }}>
                    {icon}
                </Box>
                {helpTopicPath ? (
                    <Info helpTopicPath={helpTopicPath} sx={{ gap: 0.75 }}>
                        {heading}
                    </Info>
                ) : (
                    heading
                )}
            </AccordionSummary>
            <AccordionDetails sx={{ p: 2.5, pt: 0, pb: 0.5 }}>{children}</AccordionDetails>
        </Accordion>
    );
};
